
import { defineComponent, reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import HomeMenu from "./HomeMenu.vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";

export default defineComponent({
  name: "HomeView",
  components: { HomeMenu },
  setup() {
    const { t } = useI18n();
    const lanValue = ref();
    const store = useStore();

    const data = reactive({});
    const router = useRouter();
    const open = ref<boolean>(false);
    const userName = sessionStorage.getItem("username");
    const route = useRoute();
    const currentPath = route.path;
    const logOut = () => {
      open.value = true;
    };
    const handleOk = () => {
      open.value = false;
      sessionStorage.setItem("token", "");
      router.push({ path: "/" });
    };

    const options = [
      { label: "CN", value: "zh-cn" },
      { label: "EN", value: "en" },
      { label: "RU", value: "ru" },
    ];
    const handleChangeLan = () => {
      let param = "";
      if (lanValue.value === "zh-cn") {
        param = "CN";
      }
      if (lanValue.value === "en") {
        param = "EN";
      }
      if (lanValue.value === "ru") {
        param = "RUS";
      }
      console.log("===0");
      Api.setUserLanguage(param).then((val) => {
        console.log("===1");
        if (val.err_no === ResultCodeType.success_200) {
          store.commit("setLocalLanguage", lanValue.value);
          localStorage.setItem("wxbLan", JSON.stringify(lanValue.value));
          router.go(0);
        }
      });
    };
    onMounted(() => {
      if (localStorage.getItem("wxbLan")) {
        const lanType = JSON.parse(localStorage.getItem("wxbLan") as any);
        lanValue.value = lanType;
      }
    });

    return {
      data,
      currentPath,
      logOut,
      handleOk,
      open,
      userName,
      t,
      options,
      lanValue,
      handleChangeLan,
    };
  },
});
